module.exports = __webpack_public_path__ + "img/04.e4496e01.png";